import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import GuidedSearchBoard from "./GuidedSearchBoard";
import CategoryHeaderDescription from "../../../../components/CategoryHeader/CategoryHeaderDescription";
import { normaliseVisualRefinements } from "../GuidedSearch/normaliseVisualRefinements";
import { getLocation } from "../../../../state/modules/router/selectors";
import {
  getGuidedSearchData,
  getSearchTerm,
} from "../../../../state/modules/search";

const normaliseComparableValue = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const getResolvedSearchTerm = (searchTerm, location) => {
  const normalisedSearchTerm = normaliseComparableValue(searchTerm);

  if (normalisedSearchTerm) {
    return searchTerm;
  }

  if (typeof location?.query?.q === "string") {
    return location.query.q;
  }

  return new URLSearchParams(location?.search).get("q") || "";
};

export const normaliseBoardGuidedSearchCategories = ({
  contractData,
  searchTerm,
}) => normaliseVisualRefinements(contractData, searchTerm);

const GuidedSearchBoardContainer = ({ withCategoryDescription = false }) => {
  const guidedSearchDataFromStore = useSelector(getGuidedSearchData);
  const searchTerm = useSelector(getSearchTerm);
  const location = useSelector(getLocation);

  const currentSearchTerm = getResolvedSearchTerm(searchTerm, location);

  const guidedSearchCategories = normaliseBoardGuidedSearchCategories({
    contractData: guidedSearchDataFromStore,
    searchTerm: currentSearchTerm,
  });

  if (guidedSearchCategories.length === 0) {
    return null;
  }

  const description = withCategoryDescription ? (
    <div>
      <CategoryHeaderDescription device="mobileOnly" />
      <CategoryHeaderDescription device="desktopOnly" />
    </div>
  ) : undefined;

  return (
    <GuidedSearchBoard
      guidedSearchCategories={guidedSearchCategories}
      currentPath={location?.pathname}
      currentSearch={location?.search}
      description={description}
    />
  );
};

GuidedSearchBoardContainer.propTypes = {
  withCategoryDescription: PropTypes.bool,
};

export default GuidedSearchBoardContainer;
